export default __webpack_public_path__ + "static/media/sydney-airport.2a40668c.png";